/**
 * Section display configuration - matches MBRS 1.0 section_config
 * Centralized so EditFilings and FormSectionTabs use the same display names
 */
export const sectionConfig: Record<string, { display_name: string; category: string }> = {


  //Malaysia MBRS Section configuration

  '010000_FilingInformationAbstract': {
    display_name: 'Filing Information',
    category: 'Disclosure'
  },
  '020000_DisclosureOnScopeOfFilingAbstract': {
    display_name: 'Scope Of Filing',
    category: 'Disclosure'
  },
  '120000_DisclosureOnDirectorsReportAbstract': {
    display_name: 'Directors Report',
    category: 'Disclosure'
  },
  '120100_DisclosureOnStatementByDirectorsAbstract': {
    display_name: 'Statement By Directors',
    category: 'Disclosure'
  },
  '120200_DisclosureOnDirectorsBusinessReviewAbstract': {
    display_name: 'Business Review',
    category: 'Disclosure'
  },
  '110000_DisclosureOnInvolvementInStockExchangeAbstract': {
    display_name: 'Involvement In Stock Exchange',
    category: 'Disclosure'
  },
  '130000_DisclosureOnAuditorsReportToMembersAbstract': {
    display_name: 'Auditors Report',
    category: 'Disclosure'
  },
  '200000_DisclosureOfFullSetOfFinancialStatementsAbstract': {
    display_name: 'Full Set of Financial Statements',
    category: 'Disclosure'
  },

  '200100x_DisclosureOnStatementOfFinancialPositionAbstract': {
    display_name: 'SOFP CuNonCu',
    category: 'Statements'
  },
  '200100y_DisclosureOnStatementOfFinancialPositionAbstract': {
    display_name: 'SOFP Liquidity',
    category: 'Statements'
  },
  '200200x_DisclosureOnSubclassificationOfAssetsLiabilitiesAndEquityAbstract': {
    display_name: 'SOFP CuNonCu - Details',
    category: 'Statements'
  },
  '200200y_DisclosureOnSubclassificationOfAssetsLiabilitiesAndEquityAbstract': {
    display_name: 'SOFP Liquidity - Details',
    category: 'Statements'
  },
  '300100x_DisclosureOnStatementOfProfitOrLossAbstract': {
    display_name: 'SOPL Function',
    category: 'Statements'
  },
  '300100y_DisclosureOnStatementOfProfitOrLossAbstract': {
    display_name: 'SOPL Nature',
    category: 'Statements'
  },
  '300200x_DisclosureOnStatementOfProfitOrLossAbstract': {
    display_name: 'SOPL Function - Details',
    category: 'Statements'
  },
  '300200y_DisclosureOnStatementOfProfitOrLossAbstract': {
      display_name: 'SOPL Nature - Details',
      category: 'Statements'
  },
  '400100x_DisclosureOnStatementOfComprehensiveIncomeNetOfTaxAbstract': {
    display_name: 'CI - After Tax',
    category: 'Statements'
  },
  '400100y_DisclosureOnStatementOfComprehensiveIncomeBeforeTax': {
    display_name: 'CI - Before Tax',
    category: 'Statements'
  },
  '500100x_DisclosureOnStatementOfCashFlowsAbstract': {
    display_name: 'Cash Flow - Direct',
    category: 'Statements'
  },
  '500100y_DisclosureOnStatementOfCashFlowsAbstract': {
    display_name: 'Cash Flow - Indirect',
    category: 'Statements'
  },
  '610000_DisclosureOfChangesInEquityAbstract': {
    display_name: 'SOCIE',
    category: 'Statements'
  },
  '300100x_DisclosureOnStatementOfIncomeAndExpenditureAbstract': {
    display_name: 'SOIE Function',
    category: 'Statements'
  },
  '300100y_DisclosureOnStatementOfIncomeAndExpenditureAbstract': {
    display_name: 'SOIE Nature',
    category: 'Statements'
  },
  '300200x_DisclosureOnAnalysisOfIncomeAndExpenditureAbstract': {
    display_name: 'SOIE Function - Details',
    category: 'Statements'
  },
  '300200y_DisclosureOnAnalysisOfIncomeAndExpenditureAbstract': {
    display_name: 'SOIE Nature - Details',
    category: 'Statements'
  },
  '610000_DisclosureOnStatementOfChangesInFundAbstract': {
    display_name: 'SOCIE',
    category: 'Statements'
  },
  '620000_DisclosureOfRetainedEarningsAbstract': {
    display_name: 'SORE',
    category: 'Statements'
  },
  '710000_DisclosureOnCorporateInformationAbstract': {
    display_name: 'Note - Corporate Info',
    category: 'Notes'
  },
  '720000_DisclosureOnSummaryOfSignificantAccountingPoliciesAbstract': {
    display_name: 'Note - Accounting Policy',
    category: 'Notes'
  },
  '720000_DisclosureOnSummaryOfMaterialAccountingPoliciesAbstract': {
    display_name: 'Note - Accounting Policy',
    category: 'Notes'
  },
  '730000_DisclosureOfNotesAndOtherExplanatoryInformationAbstract': {
    display_name: 'Note - Other',
    category: 'Notes'
  },
  '740000_DisclosureOnIssuedCapitalAbstract': {
    display_name: 'Note - Issued Capital',
    category: 'Notes'
  },
  '750000_DisclosureOnRelatedPartyTransactionsAbstract': {
    display_name: 'Note - Related Party',
    category: 'Notes'
  },

  //Malaysia CLBG/CLBS 1965 Section configuration

  '130000_AuditorsReportAbstract': {
    display_name: 'Auditors Report',
    category: 'Disclosure'
  },

  '210000_StatementOfFinancialPositionAbstract': {
    display_name: 'SOFP CuNonCu ',
    category: 'Statements'
  },

  '220000_StatementOfFinancialPositionAbstract': {
    display_name: 'SOFP Liquidity',
    category: 'Statements'
  },

  '310000_StatementOfProfitOrLossAbstract': {
    display_name: 'SOPL',
    category: 'Statements'
  },

  '210000_DisclosureOnStatementOfFinancialPositionAbstract': {
    display_name: 'SOFP CuNonCu ',
    category: 'Statements'
  },

  '220000_DisclosureOnStatementOfFinancialPositionAbstract': {
    display_name: 'SOFP Liquidity',
    category: 'Statements'
  },

  '310000_DisclosureOnStatementOfProfitOrLossAbstract': {
    display_name: 'SOPL',
    category: 'Statements'
  },


  //Singapore ACRA Section configuration

  '10000000_DisclosureOfFilingInformationAbstract': {
    display_name: 'Filing Information',
    category: 'Disclosure'
  },

  '11000000_DisclosureOfCompleteSetOfFinancialStatementsAbstract': {
    display_name: 'Full Set Statements',
    category: 'Disclosure'
  },

  '12000000_DisclosureInStatementByDirectorsAbstract': {
    display_name: 'Directors Statement',
    category: 'Disclosure'
  },
  '13000000_DisclosuresInIndependentAuditorsReportAbstract': {
    display_name: 'Auditors Report',
    category: 'Disclosure'
  },
  '14000000_DisclosureOfAdditionalInformationAbstract': {
    display_name: 'Additional Information',
    category: 'Disclosure'
  },
  '21100000_StatementOfFinancialPositionAbstract': {
    display_name: 'SOFP CuNonCu',
    category: 'Statements'
  },
  '22000000_StatementOfProfitOrLossAbstract': {
    display_name: 'SOPL Nature',
    category: 'Statements'
  },
  '23000000_StatementOfCashFlowsAbstract': {
    display_name: 'SOCF',
    category: 'Statements'
  },
  '31000000_TradeAndOtherReceivablesAbstract': {
    display_name: 'Trade and Other Receivables',
    category: 'Notes'
  },
  '32000000_DisclosureOfDetailedInformationAboutPropertyPlantAndEquipmentAbstract': {
    display_name: 'Property Plant Equipment',
    category: 'Notes'
  },
  '33000000_DisclosureOfIntangibleAssetsAbstract': {
    display_name: 'Intangible Assets',
    category: 'Notes'
  },
  '34000000_DisclosureOfRightofuseAssetsAbstract': {
    display_name: 'Right of use Assets',
    category: 'Notes'
  },
  '35000000_TradeAndOtherPayablesAbstract': {
    display_name: 'Trade and Other Payables',
    category: 'Notes'
  },
  '36000000_DisclosureOfLoansAndBorrowingsAbstract': {
    display_name: 'Loans and Borrowings',
    category: 'Notes'
  },
  '37000000_DisclosureOfRevenueAbstract': {
    display_name: 'Revenue',
    category: 'Notes'
  },
  '38000000_DisclosureOfSelectedIncomeExpensesAbstract': {
    display_name: 'Selected Income Expenses',
    category: 'Notes'
  },
  '39000000_RelatedPartyTransactionsAbstract': {
    display_name: 'Related Party',
    category: 'Notes'
  },
};

